/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Directory_Submit_Review_Fast_Track_PriceInputs */

const en_directory_submit_review_fast_track_price = /** @type {(inputs: Directory_Submit_Review_Fast_Track_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} one-time`)
};

const zh_directory_submit_review_fast_track_price = /** @type {(inputs: Directory_Submit_Review_Fast_Track_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} 一次性`)
};

/**
* | output |
* | --- |
* | "{price} one-time" |
*
* @param {Directory_Submit_Review_Fast_Track_PriceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_fast_track_price = /** @type {((inputs: Directory_Submit_Review_Fast_Track_PriceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Fast_Track_PriceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_fast_track_price(inputs)
	return zh_directory_submit_review_fast_track_price(inputs)
});
export { directory_submit_review_fast_track_price as "directory.submit.review.fast_track_price" }